import { ɵɵdefineInjectable, ɵɵinject, Injectable, Optional } from '@angular/core';
import { CookieService } from 'ngx-cookie';

/**
 * Used to define the object for passing search parameters to the backend
 * @property {string} query
 * @property {number} [skip]
 * @property {number} [take]
 * @property {object[]} [extraParams]
 * @property {string} [order]
 * @property {string} [orderDirection]
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-cookie';
class SearchParams {
    constructor(searchParams) {
        this.query = searchParams.query;
        this.skip = searchParams.skip;
        this.take = searchParams.take;
        this.extraParams = searchParams.extraParams;
        this.order = searchParams.order;
        this.orderDirection = searchParams.orderDirection;
    }
}
/**
 * Used to define the object for when you want to pass in additional
 * search parameters not from the main input.
 */
class ExtraSearchParams {
    constructor(extraSearchParams) {
        this.name = extraSearchParams.name;
        this.value = extraSearchParams.value;
        this.valueArray = extraSearchParams.valueArray;
    }
}

class CookieStrategyService {
}

class PortalCookieStrategy extends CookieStrategyService {
    /**
     *
     */
    constructor(storage) {
        super();
        this.storage = storage;
    }
    // Converting this to a promise so we can parse it consistently regardless of the strategy.
    get(key) {
        return Promise.resolve(this.storage.get(key));
    }
    set(key, value, options) {
        return this.storage.put(key, value, options);
    }
    remove(key) {
        return this.storage.remove(key);
    }
}

class StorageService extends CookieStrategyService {
    constructor(cookieStrategyService, cookieService) {
        super();
        if (!cookieStrategyService) {
            cookieStrategyService = new PortalCookieStrategy(cookieService);
        }
        Object.assign(this, cookieStrategyService);
        this.get = cookieStrategyService.get.bind(cookieStrategyService);
        this.set = cookieStrategyService.set.bind(cookieStrategyService);
        this.remove = cookieStrategyService.remove.bind(cookieStrategyService);
    }
    get(key) {
        throw new Error('Method not implemented.');
    }
    set(key, value, options) {
        throw new Error('Method not implemented.');
    }
    remove(key) {
        throw new Error('Method not implemented.');
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(ɵngcc0.ɵɵinject(CookieStrategyService, 8), ɵngcc0.ɵɵinject(ɵngcc1.CookieService)); };
StorageService.ɵprov = ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(ɵɵinject(CookieStrategyService, 8), ɵɵinject(CookieService)); }, token: StorageService, providedIn: "root" });
StorageService.ctorParameters = () => [
    { type: CookieStrategyService, decorators: [{ type: Optional }] },
    { type: CookieService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: CookieStrategyService, decorators: [{
                type: Optional
            }] }, { type: ɵngcc1.CookieService }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CookieStrategyService, ExtraSearchParams, SearchParams, StorageService };

//# sourceMappingURL=mt-ng2-common-classes.js.map